import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import PaginationItem from '@material-ui/lab/PaginationItem';
import moment from 'moment';
import {
  setSystemLodingFLg,
} from '../../actions/CommonAction';
import {
  getCompanySearchList,
  setTargetListCategory,
  startDownloadPolling,
  stopDownloadPolling,
  getDownloadStatus,
} from '../../actions/TargetAction';
import {
  searchCompanyHierarchyList,
  searchCompanyOfficeInfo,
  searchCompanyOfficeInfoLight,
  setHierarchyKbn,
  setCompanyInfo,
  setBlindFlg,
  setParentsLinkBlindFlg,
  setRootLinkBlindFlg,
  setAreaHierarchyFlg,
} from '../../actions/CompanyAction';
import {
  SEARCH_TARGET_CONDITION,
  ROLE_CODE,
  PAGING,
  HIERARCHY_KBN,
  DISP_COUNT_LIMIT,
  LIGHT_FLG,
  RESULT_CODE,
  TARGET_LIST_CATEGORY,
  TARGET_SEARCH_RESULT_DISP_ITEM,
  ITEM_NAME_EN,
  DOWNLOAD_DISP_STATUS,
  DATE_TIME_FORMAT,
  PROCESS_STATUS,
  DOWNLOAD_STATUS_MESSAGE,
} from '../../../common/const';
import styles from './style.module.css';
import { getMessage } from '../../../common/util';

/**
 * ターゲットリストタブ
 */
class TargetListComponent extends Component {
  async componentDidMount() {
    const {
      setTargetListCategoryAct,
      targetingDispItems,
      dispSearchCondition,
      startDownloadPollingAct,
      getDownloadStatusAct,
    } = this.props;

    // ダウンロードステータス情報取得
    const ret = await getDownloadStatusAct();
    // ダウンロードステータスが処理中の場合、ポーリング処理を開始
    if (ret) {
      await startDownloadPollingAct();
    }

    let targetListCategory;

    // 検索結果一覧に表示用カテゴリー設定
    if (dispSearchCondition.search_target === SEARCH_TARGET_CONDITION.SEARCH_TARGET_ONE) {
      // 検索対象（本社のみ）が'1'の場合
      if (targetingDispItems.search_result_list.some(
        (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.GYOSYU,
      )
        && targetingDispItems.search_result_list.some(
          (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.JYUGYOINSU,
        )
        && targetingDispItems.search_result_list.some(
          (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.URIAGEDAKA,
        )) {
        // 業種、従業員数、売上高が存在する場合
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY1;
      } else if (targetingDispItems.search_result_list.some(
        (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.JYUGYOINSU,
      )
        && targetingDispItems.search_result_list.some(
          (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.URIAGEDAKA,
        )) {
        // 従業員数、売上高が存在する場合
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY2;
      } else if (targetingDispItems.search_result_list.some(
        (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.GYOSYU,
      )
        && targetingDispItems.search_result_list.some(
          (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.URIAGEDAKA,
        )) {
        // 業種、売上高が存在する場合
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY3;
      } else if (targetingDispItems.search_result_list.some(
        (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.GYOSYU,
      )
        && targetingDispItems.search_result_list.some(
          (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.JYUGYOINSU,
        )) {
        // 業種、従業員数が存在する場合
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY4;
      } else if (targetingDispItems.search_result_list.some(
        (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.URIAGEDAKA,
      )) {
        // 売上高が存在する場合
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY5;
      } else if (targetingDispItems.search_result_list.some(
        (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.JYUGYOINSU,
      )) {
        // 従業員数が存在する場合
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY6;
      } else if (targetingDispItems.search_result_list.some(
        (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.GYOSYU,
      )) {
        // 業種が存在する場合
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY7;
      } else {
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY8;
      }
    } else if (dispSearchCondition.search_target === SEARCH_TARGET_CONDITION.SEARCH_TARGET_ALL) {
      // 検索対象（本社のみ）が'2'の場合
      if (targetingDispItems.search_result_list.some(
        (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.GYOSYU,
      )
        && targetingDispItems.search_result_list.some(
          (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.JYUGYOINSU,
        )
        && targetingDispItems.search_result_list.some(
          (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.URIAGEDAKA,
        )) {
        // 業種、従業員数、売上高が存在する場合
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY9;
      } else if (targetingDispItems.search_result_list.some(
        (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.JYUGYOINSU,
      )
        && targetingDispItems.search_result_list.some(
          (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.URIAGEDAKA,
        )) {
        // 従業員数、売上高が存在する場合
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY10;
      } else if (targetingDispItems.search_result_list.some(
        (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.GYOSYU,
      )
        && targetingDispItems.search_result_list.some(
          (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.URIAGEDAKA,
        )) {
        // 業種、売上高が存在する場合
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY11;
      } else if (targetingDispItems.search_result_list.some(
        (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.GYOSYU,
      )
        && targetingDispItems.search_result_list.some(
          (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.JYUGYOINSU,
        )) {
        // 業種、従業員数が存在する場合
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY12;
      } else if (targetingDispItems.search_result_list.some(
        (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.URIAGEDAKA,
      )) {
        // 売上高が存在する場合
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY13;
      } else if (targetingDispItems.search_result_list.some(
        (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.JYUGYOINSU,
      )) {
        // 従業員数が存在する場合
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY14;
      } else if (targetingDispItems.search_result_list.some(
        (item) => item.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.GYOSYU,
      )) {
        // 業種が存在する場合
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY15;
      } else {
        targetListCategory = TARGET_LIST_CATEGORY.LIST_CATEGORY16;
      }
    }
    setTargetListCategoryAct(targetListCategory);
  }

  componentWillUnmount() {
    const { stopDownloadPollingAct } = this.props;
    // ポーリング処理を停止
    stopDownloadPollingAct();
  }

  /**
  * 企業検索画面を表示する
  */
  showCompanyDetail = async (kigyoCode) => {
    const {
      setSystemLodingFLgAct,
      searchCompanyHierarchyListAct,
      searchCompanyOfficeInfoAct,
      setHierarchyKbnAct,
      history,
      searchCompanyOfficeInfoLightAct,
      setCompanyInfoAct,
      setBlindFlgAct,
      setAreaHierarchyFlgAct,
      setParentsLinkBlindFlgAct,
      setRootLinkBlindFlgAct,
      userInfo,
    } = this.props;

    setSystemLodingFLgAct(true);
    setCompanyInfoAct();
    // 企業階層情報取得
    const ret = await searchCompanyHierarchyListAct(kigyoCode);
    if (ret) {
      // 対象企業の事業所詳細を表示したいので、企業コードで事業所詳細情報を検索
      if (userInfo.light_flag === LIGHT_FLG.ON) {
        // ライト版の処理
        const retOffice = await searchCompanyOfficeInfoLightAct(kigyoCode);
        if (retOffice.result === RESULT_CODE.SUCCESS) {
          // ステータスが「200」の場合
          setCompanyInfoAct(retOffice.response);
          setBlindFlgAct(false);
          setAreaHierarchyFlgAct(false);
          // 国内親会社及び国内最上位親会社で事業情報詳細取得
          if (retOffice.response.display_list) {
            let parentsCode;
            let rootsCode;
            retOffice.response.display_list.forEach((dList) => {
              if (dList.display_column === ITEM_NAME_EN.OYA_DUNS
                || dList.display_column === ITEM_NAME_EN.OYA_TSR) {
                [, parentsCode] = dList.display_value;
              } else if (dList.display_column === ITEM_NAME_EN.SIJO_OYA_DUNS
                || dList.display_column === ITEM_NAME_EN.SIJO_OYA_TSR) {
                [, rootsCode] = dList.display_value;
              }
            });
            if (parentsCode) {
              const retParents = await searchCompanyOfficeInfoLightAct(
                parentsCode,
              );
              // ステータスが「404」の場合は、国内親会社リンク表示フラグをfalseに設定する。
              if (retParents.result === RESULT_CODE.NOT_FOUND) {
                setParentsLinkBlindFlgAct(true);
              } else {
                setParentsLinkBlindFlgAct(false);
              }
            }
            if (rootsCode) {
              const retRoots = await searchCompanyOfficeInfoLightAct(rootsCode);
              // ステータスが「404」の場合は、国内親会社リンク表示フラグをfalseに設定する。
              if (retRoots.result === RESULT_CODE.NOT_FOUND) {
                setRootLinkBlindFlgAct(true);
              } else {
                setRootLinkBlindFlgAct(false);
              }
            }
          }
        } else if (retOffice.result === RESULT_CODE.NOT_FOUND) {
          // ステータスが「404」の場合は非公開フラグをtrueに設定
          setCompanyInfoAct();
          setBlindFlgAct(true);
          setAreaHierarchyFlgAct(true);
        } else {
          // ステータスが「200」でも「404」でも無い場合は異常系として処理
          setCompanyInfoAct();
        }
      } else {
        // 非ライト版の処理
        await searchCompanyOfficeInfoAct(kigyoCode);
      }
      // 階層情報区分値設定
      setHierarchyKbnAct(HIERARCHY_KBN.FUND);
    }
    // 企業検索画面を表示
    history.push('/searchcompany');
    setSystemLodingFLgAct(false);
  }

  /**
   * ページ選択
   */
  changePage = async (page) => {
    const {
      getCompanySearchListAct,
      setSystemLodingFLgAct,
    } = this.props;

    setSystemLodingFLgAct(true);
    // ページ番号を指定して検索処理実行
    await getCompanySearchListAct(page);
    setSystemLodingFLgAct(false);
  }

  render() {
    const {
      companySearchList,
      nowpage,
      userInfo,
      targetListHeaderItem,
      targetListCategory,
      targetingDispItems,
      dispSearchCondition,
      downloadStatus,
    } = this.props;

    // ダウンロードステータス表示判定 ここから
    let createDateMessage = null;
    let downloadStateMessage = null;
    if (downloadStatus
      && downloadStatus.status
      && DOWNLOAD_DISP_STATUS.includes(downloadStatus.status)) {
      // ファイル作成日付の文言作成
      createDateMessage = downloadStatus.create_datetime
        ? `${moment(
          downloadStatus.create_datetime, DATE_TIME_FORMAT.DATE_TIME_FULL,
        ).format(DATE_TIME_FORMAT.DATE_TIME)} 作成分`
        : null;

      // ダウンロードステータスに応じた文言を作成
      if (downloadStatus.status === PROCESS_STATUS.PROCESSING) {
        // 処理中
        downloadStateMessage = !Number.isNaN(downloadStatus.read_count)
          ? getMessage(DOWNLOAD_STATUS_MESSAGE.PROCESSING,
            Number(downloadStatus.read_count).toLocaleString())
          : null;
      } else if (downloadStatus.status === PROCESS_STATUS.INTERRUPT) {
        // 中断
        downloadStateMessage = DOWNLOAD_STATUS_MESSAGE.INTERRUPT;
      } else if (downloadStatus.status === PROCESS_STATUS.ANOMALY) {
        // 異常終了
        downloadStateMessage = DOWNLOAD_STATUS_MESSAGE.ANOMALY;
      }
    }
    // ダウンロードステータス表示判定 ここまで

    // ページングの表示処理 ここから
    let pagingArea = null;

    // 全体件数
    let totalCount = null;

    // 全体件数が最大取得件数以上の場合、全体件数を最大取得件数に設定
    if (companySearchList
      && companySearchList.all_count) {
      totalCount = companySearchList.all_count < DISP_COUNT_LIMIT.TARGET
        ? companySearchList.all_count : DISP_COUNT_LIMIT.TARGET;
    }

    if (companySearchList
      && totalCount) {
      const maxPageCount = totalCount === 0
        ? 1
        : Math.ceil(totalCount / PAGING.PAGE_RECORD_COUNT);
      // 最後のページ数を算出
      const endPageCount = nowpage + PAGING.AFTER_PAGE_COUNT < maxPageCount
        ? nowpage + PAGING.AFTER_PAGE_COUNT
        : maxPageCount;
      // 最初のページ数を算出
      const startPageCount = nowpage - PAGING.BEFORE_PAGE_COUNT > 1
        ? nowpage - PAGING.BEFORE_PAGE_COUNT
        : 1;
      const pageList = [];
      if (startPageCount > 1) {
        pageList.push(<span key={1} className="space">...</span>);
      }
      for (let count = startPageCount; count <= endPageCount; count += 1) {
        pageList.push(
          <span
            key={count}
            className={[
              endPageCount === count ? 'last-page-link' : 'page-link',
              nowpage === count ? 'nowpage' : '',
            ].join(' ')}
            onClick={nowpage === count
              ? null
              : this.changePage.bind(this, count)}
          >
            {count}
          </span>,
        );
      }
      if (endPageCount < maxPageCount) {
        pageList.push(<span key={maxPageCount} className="space">...</span>);
      }
      pagingArea = (
        <Pagination
          variant="outlined"
          count={maxPageCount}
          onChange={(e, page) => this.changePage(page)}
          page={nowpage}
          renderItem={(item) => (
            <PaginationItem
              {...item}
              disabled={
                item.page === nowpage
                || (item.type === 'next' && nowpage === maxPageCount)
                || (item.type === 'previous' && nowpage === 1)
              }
              className={`${item.page === nowpage ? styles.customPaginationItem : ''}`}
            />
          )}
        />
      );
    }
    // ページングの表示処理 ここまで
    // 表示件数作成
    const dispCountStart = (nowpage - 1) * PAGING.PAGE_RECORD_COUNT + 1;
    const dispCountEnd = (companySearchList
      && companySearchList.result_count
      && totalCount
      && totalCount <= DISP_COUNT_LIMIT.TARGET)
      ? (nowpage - 1) * PAGING.PAGE_RECORD_COUNT + Number(companySearchList.result_count)
      : null;
    const dispResultCount = dispCountEnd ? `${dispCountStart}-${dispCountEnd}` : 0;

    // 全体件数
    const allCount = (companySearchList && totalCount)
      ? Number(totalCount).toLocaleString()
      : 0;

    let tableWidth = 0;

    // ヘッダー項目設定
    const targetListHeaderItems = targetListHeaderItem.map((header) => {
      let dom = null;
      if (header.item_category === targetListCategory) {
        dom = (
          <TableCell
            key={`key-${header.item_code}-tc`}
            className={`
              ${styles.tableHeadCell}
              ${styles.searchResultareaHeaderCell}
            `}
            style={{ width: `${header.item_width}%`, minWidth: `${header.item_width}` }}
          >
            {header.item_name}
          </TableCell>
        );
        tableWidth += header.item_width;
      }
      return dom;
    });

    // ヘッダー項目設定（取引情報）
    if (dispSearchCondition.trade_list && dispSearchCondition.trade_list.length > 0) {
      targetListHeaderItems.push(targetListHeaderItem.map((header) => {
        let dom = null;
        if (header.item_class === 'additionalitem') {
          dom = (
            <TableCell
              key={`key-${header.item_code}-tc-trade`}
              className={`
                ${styles.tableHeadCell}
                ${styles.searchResultareaHeaderCell}
                ${styles.tradeInfoBgColor}
              `}
              style={{ width: `${header.item_width}%`, minWidth: `${header.item_width}` }}
            >
              {header.item_name}
            </TableCell>
          );
          tableWidth += header.item_width;
        }
        return dom;
      }));
    }

    return (
      <Box className={`${styles.targetcompanylist}`}>
        <Box className={`${styles.listContainer}`}>
          <Box className={`${styles.resultcount}`}>
            <Box className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                  <Box component="span" className={`${styles.searchResult}`}>{dispResultCount}</Box>
                  {` / ${allCount}件`}
                </Box>
                {downloadStatus.status !== PROCESS_STATUS.SUCCESS_OK
                  && createDateMessage
                  && downloadStateMessage
                  && (
                    <Box className={`${styles.downloadStatus}`}>
                      <span>{createDateMessage}</span>
                      <span className={`${styles.message}`}>{downloadStateMessage}</span>
                    </Box>
                  )}
              </Box>
            </Box>

            <Box display="flex" justifyContent="space-between" alignItems="center">
              {pagingArea}
              {(companySearchList && companySearchList.all_count > 10000) && (
                <Box className={`${styles.downloadMessage}`}>
                  ※最大10000件までしか表示されません。全ての検索結果を確認するには「ダウンロードリクエスト」を実行してください。
                </Box>
              )}
            </Box>

          </Box>
          <Box className={`${styles.searchResultarea}`}>
            <TableContainer
              className={`${styles.tableContainer}`}
              style={{ width: `${tableWidth}%` }}
            >
              <Table className={`${styles.tableArea}`}>
                <TableHead>
                  <TableRow>
                    {targetListHeaderItems}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {companySearchList
                    && companySearchList.company_list
                    && companySearchList.company_list.map((resultset, index) => (
                      <TableRow
                        key={`page-${nowpage}-${resultset.office_code}-${index}`}
                        // 企業検索画面の表示権限がある場合、企業階層を表示
                        onClick={userInfo.role_list.includes(ROLE_CODE.COMPANY)
                          ? () => this.showCompanyDetail(resultset.kigyo_code)
                          : null}
                        className={`${styles.resultRow}`}
                      >
                        <TableCell key={index} className={`${styles.tableBodyCell}`}>
                          {resultset.trade_name || ''}
                        </TableCell>
                        {/* 事業所 */}
                        {(dispSearchCondition.search_target
                          === SEARCH_TARGET_CONDITION.SEARCH_TARGET_ALL)
                          && <TableCell className={`${styles.tableBodyCell}`}>{resultset.office_name || ''}</TableCell>}
                        {/* 所在地 */}
                        <TableCell className={`${styles.tableBodyCell}`}>{resultset.address || ''}</TableCell>
                        {/* 業種 */}
                        {(!targetingDispItems.search_result_list.some(
                          (result) => result.item_name === TARGET_SEARCH_RESULT_DISP_ITEM.GYOSYU,
                        ))
                          && <TableCell className={`${styles.tableBodyCell}`}>{resultset.industry || ''}</TableCell>}
                        {/* 従業員数 */}
                        {(!targetingDispItems.search_result_list.some(
                          (result) => result.item_name
                            === TARGET_SEARCH_RESULT_DISP_ITEM.JYUGYOINSU,
                        ))
                          && (
                            <TableCell className={`${styles.tableBodyCell}`}>
                              {resultset.employees_num
                                && !Number.isNaN(Number(resultset.employees_num))
                                ? `${Number(resultset.employees_num).toLocaleString()}人`
                                : ''}
                            </TableCell>
                          )}
                        {/* 当期売上高 */}
                        {(!targetingDispItems.search_result_list.some(
                          (result) => result.item_name
                            === TARGET_SEARCH_RESULT_DISP_ITEM.URIAGEDAKA,
                        ))
                          && (
                            <TableCell className={`${styles.tableBodyCell}`}>
                              {resultset.sales
                                && !Number.isNaN(Number(resultset.sales))
                                ? `${Number(resultset.sales).toLocaleString()}千円`
                                : ''}
                            </TableCell>
                          )}
                        {/* 取引情報 */}
                        {(dispSearchCondition.trade_list
                          && dispSearchCondition.trade_list.length > 0)
                          && resultset.trade_info && resultset.trade_info.map((trade) => (
                            <>
                              <TableCell className={`${styles.tableBodyCell}`}>{trade || ''}</TableCell>
                            </>
                        ))}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Box>
    );
  }
}
export default connect(
  (state) => ({
    companySearchList: state.target.companySearchList,
    dispSearchCondition: state.target.dispSearchCondition,
    nowpage: state.target.nowpage,
    userInfo: state.common.userInfo,
    limitMessage: state.target.limitMessage,
    targetListHeaderItem: state.target.targetListHeaderItem,
    targetListCategory: state.target.targetListCategory,
    targetingDispItems: state.target.targetingDispItems,
    downloadStatus: state.target.downloadStatus,
  }),
  (dispatch) => ({
    getCompanySearchListAct: (obj) => dispatch(getCompanySearchList(obj)),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    searchCompanyHierarchyListAct: (obj) => dispatch(searchCompanyHierarchyList(obj)),
    searchCompanyOfficeInfoAct: (obj) => dispatch(searchCompanyOfficeInfo(obj)),
    searchCompanyOfficeInfoLightAct: (str) => dispatch(searchCompanyOfficeInfoLight(str)),
    setHierarchyKbnAct: (str) => dispatch(setHierarchyKbn(str)),
    setBlindFlgAct: (bool) => dispatch(setBlindFlg(bool)),
    setCompanyInfoAct: (obj) => dispatch(setCompanyInfo(obj)),
    setParentsLinkBlindFlgAct: (bool) => dispatch(setParentsLinkBlindFlg(bool)),
    setRootLinkBlindFlgAct: (bool) => dispatch(setRootLinkBlindFlg(bool)),
    setAreaHierarchyFlgAct: (bool) => dispatch(setAreaHierarchyFlg(bool)),
    setTargetListCategoryAct: (num) => dispatch(setTargetListCategory(num)),
    startDownloadPollingAct: () => dispatch(startDownloadPolling()),
    getDownloadStatusAct: () => dispatch(getDownloadStatus()),
    stopDownloadPollingAct: () => dispatch(stopDownloadPolling()),
  }),
)(withRouter(TargetListComponent));
